import {
  Col,
  Form,
  Input,
  Row,
  Typography,
  Button as AntButton,
  message,
  Divider,
} from "antd";
import { Button, LanguageChange } from "shared/components";
import { Trans, useTranslation } from "react-i18next";
import { Auth } from "aws-amplify";
import { RouterProps } from "react-router";
import { useDispatch } from "react-redux";
import { getLoggedUser } from "explorer/reducers/users";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import { ReactComponent as MailIcon } from "shared/assets/images/icon-mail.svg";
import { ReactComponent as LockIcon } from "shared/assets/images/icon-lock.svg";
import { ReactComponent as LoginIcon } from "shared/assets/images/icon-log-in.svg";
import { useState } from "react";
import { getGeneros, getGenerosSpotify } from "explorer/reducers/generos";
import {
  fetchUserDeviceCheck,
  putChangeLanguage,
} from "shared/service/StrmService";
import { TOKEN, USER } from "shared/constants/LocalStorageConsts";
import { getBrowserId, loadUserId } from "shared/helpers/browser-id";
import { getCountries } from "explorer/reducers/countries";
import { loginReduced } from "explorer/reducers/auth";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import RecordGirl from "shared/assets/images/record-girl-tall.png";
import "../cadastre-se/CadastreSe.scss";
import "./Login.scss";
import { getMonitoredData } from "explorer/reducers/monitored-data";

const Login: React.FC<RouterProps> = (props) => {
  const { history } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const { t, i18n } = useTranslation("explorer");
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const onFinish = async () => {
    const values = await form.validateFields();
    setLoading(true);
    try {
      const browserId = getBrowserId();
      localStorage.clear();
      loadUserId(browserId);
      const user = await Auth.signIn(values.email, values.password);
      localStorage.setItem(USER, JSON.stringify(user));
      localStorage.setItem(TOKEN, user.signInUserSession.idToken.jwtToken);
      const check = await fetchUserDeviceCheck(getBrowserId());
      if (check) {
        if (i18n.language) await putChangeLanguage(i18n.language);
        dispatch(getLoggedUser());
        dispatch(getGenerosSpotify());
        dispatch(getGeneros());
        dispatch(getCountries());
        dispatch(loginReduced());
        dispatch(getMonitoredData());
        const returnURL = sessionStorage.getItem("returnURL");
        sessionStorage.removeItem("returnURL");
        if (returnURL) history.push(returnURL);
        else history.push("/");
      } else {
        history.push("/verificacao-dispositivo");
      }
    } catch (error: any) {
      if (error.code === "UserNotConfirmedException") {
        history.push("/verificacao", {
          name: values.name,
          login: values.email,
        });
      }

      if (error.code === "NotAuthorizedException")
        message.error(t("pages.Login.loginInvalido"));
      else message.error(error.message);
    }

    setLoading(false);
  };

  return (
    <Row className="login">
      {isMobile && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <LanguageChange.SelectLanguageChange />
        </div>
      )}
      <Col
        xs={isMobile ? 24 : 10}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <div className="container" style={{ padding: isMobile ? 12 : 0 }}>
          <Row className="fedarated-buttons" gutter={18}>
            <Col xs={24}>
              <div className="logo-region">
                <Logo className="logo" style={{ width: isMobile ? 80 : 100 }} />
                <span style={{ fontSize: isMobile ? 14 : 28 }}>for labels</span>
              </div>
            </Col>
            <Col span={24}>
              <Typography.Text
                className="text social"
                style={{ color: "#888" }}
              >
                {t("pages.CadastreSe.socialText")}
              </Typography.Text>
            </Col>
            <Col xs={12}>
              <Button.Google />
            </Col>
            <Col span={12}>
              <Button.Facebook />
            </Col>
          </Row>
          <Divider className="divider">{t("pages.Login.ou")}</Divider>
          <Row>
            <Col span={24}>
              <Form
                layout={"vertical"}
                form={form}
                onFinish={onFinish}
                autoComplete="off"
              >
                <div className="content">
                  <div className="input">
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: t("pages.Login.emailObrigatorio"),
                        },
                        {
                          type: "email",
                          message: t("pages.Login.emailValido"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("pages.Login.email")}
                        size="large"
                        prefix={<MailIcon />}
                      />
                    </Form.Item>

                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: t("pages.Login.senhaObrigatorio"),
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder={t("pages.Login.senha")}
                        size="large"
                        prefix={<LockIcon />}
                      />
                    </Form.Item>
                  </div>

                  <div className="enter-button">
                    <button
                      className="botao-roxo"
                      disabled={loading}
                      style={{ padding: "12px 16px" }}
                    >
                      {t("pages.Login.entrar")} <LoginIcon />
                    </button>
                  </div>
                  <div className="esqueci-senha">
                    <AntButton
                      type="link"
                      htmlType="button"
                      onClick={() => history.push("/reset-senha")}
                      className="button-reset-senha"
                    >
                      {t("pages.Login.esqueciSenha")}
                    </AntButton>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
          <Row className="row-register">
            <Col span={24}>
              <div className="text-register back-login">
                {t("pages.Login.noAccountMessage")}
                <Link style={{ marginLeft: 6 }} to="/cadastre">
                  {t("pages.Login.cadastre")}
                </Link>
              </div>
            </Col>
          </Row>
          <span
            style={{
              display: "flex",
              borderBottom: "1px solid #272727",
              marginTop: 22,
            }}
          />

          <span className="outras-plataformas-titulo">
            {t("pages.Login.acesseOutraPlataforma")}
          </span>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a
              href={process.env.REACT_APP_STRM_ARTIST_URL}
              className="outras-plataformas"
            >
              <span>
                <Logo style={{ width: 67 }} />
                for artists
              </span>
            </a>
          </div>
        </div>
      </Col>
      <Col xs={14} hidden={isMobile}>
        <div className="caixa-copy">
          <div className="copy-content">
            {!isMobile && <LanguageChange.SelectLanguageChange />}
            <img src={RecordGirl} alt="girl playing drum" />
            <div className="copy">
              <h1>{t("pages.Login.exploreSuaCarreira")}</h1>
              <ul>
                <li className="azul">
                  <Trans i18nKey={t("pages.Login.suaCarreiraUm")} />
                </li>
                <li className="roxo">
                  <Trans i18nKey={t("pages.Login.suaCarreiraDois")} />
                </li>
                <li className="rosa">
                  <Trans i18nKey={t("pages.Login.suaCarreirTres")} />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Login;
